module.exports = __webpack_public_path__ + "img/jingkong.4c8211a8.png";